<script>
  import BrandLayout from '../components/Layout'
  import ArticleContent from '@components/Article/ArticleContent'
  import ArticleFooter from '@components/Article/ArticleFooter'
  import ArticleSide from '@components/Article/ArticleSide'
  import ArticleKeyWord from '@components/Article/ArticleKeyWord'
  import ArticleSticky from '@components/Article/ArticleSticky'
  import pageGAMixin from "../mixins/pageGA";

  export default {
    page() {
      return {
        title: `${this.defaultValue.title} | 產品影片`,
      }
    }, 
    components: {
      BrandLayout,
      ArticleContent,
      ArticleFooter,
      ArticleSide,
      ArticleKeyWord,
      ArticleSticky
    },
    mixins: [pageGAMixin],
    props: {
      defaultValue: {
        type: Object,
        default: () => {
        }
      }
    },
    data() {
      return {
        type: 'video',

      }
    },
    computed: {
      brandLink() {
        const { brands } = this.defaultValue
        return [
          {
            alias: brands[0].alias,
            logo_image: brands[0].logo_image,
            contact: brands[0].contact,
            title: brands[0].title,
          }
        ]
      },
      videoId() {
        const { extrafields: { youtube_url: { value = '' } } } = this.defaultValue
        if(value) {
          const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
          const match = value.match(regExp);
          return (match && match[7].length === 11)
            ? match[7]
            : false;
        }
        return '';
      },
    },
    
    methods: {
      backTo(to) {
        const name = () => {
          switch(to) {
            case 'video-item':
              return 'video-list';
            case 'brand-video-item':
              return 'brand-video-list'
          }
        };
        const params = () => {
          switch(to) {
            case 'video-item':
              return undefined;
            case 'brand-video-item':
              return {
                brandAlias: this.$route.params.brandAlias,
              };
          }
        };
        return {
          name: name(),
          params: params()
        }
      },
      playVideo() {
        this.$refs.youtube.player.playVideo()
      },
    },
  }
</script>
<template>
  <BrandLayout :page-type="type">
    <BaseBanner
      :title="defaultValue.title"
      type="article"
      :image="defaultValue.image ? defaultValue.image : ''"
      class="d-lg-block d-none"
    />
    <div
      v-if="videoId"
      class="mb-4 d-lg-none"
      :class="$style.video"
      @click="playVideo"
    >
      <youtube
        ref="youtube"
        :video-id="videoId"
        class="youtube"
      ></youtube>
    </div>
    <div class="container">
      <div class="d-md-none">
        <div class="text-lg font-medium">{{ defaultValue.title }}</div>
        <div class="text-2sm color-gray-6 mt-3">
          <i class="icomoon icon-time text-sm"></i>
          發布時間：{{ defaultValue.publish_up }}
        </div>
      </div>
      <div class="row">
        <div class="col-lg-7 order-lg-first order-last">
          <ArticleContent
            :article-text="defaultValue.description"
            :time="defaultValue.publish_up"
          >
            <div
              v-if="videoId"
              class="mb-5 d-lg-block d-none"
              :class="$style.video"
              @click="playVideo"
            >
              <youtube
                ref="youtube"
                :video-id="videoId"
                class="youtube"
              ></youtube>
            </div>
          </ArticleContent>
          <ArticleKeyWord
            v-if="defaultValue.tags.length"
            :list="defaultValue.tags"
            class="mt-4 d-lg-none"
          />
          <ArticleFooter
            :data="{
              ...defaultValue,
              to: backTo($route.name),
            }"
            :text="$route.name === 'video-item' ? '影片專區' : '產品影片' "
            :content-type="type"
          />
        </div>
        <div class="col-lg-5">
          <BaseSticky
            :offset="-190"
            :banner-height="415"
            :menu-height="113"
            :space-top="40"
            :space-bottom="40"
          >
            <ArticleSide
              :type="type"
              :info="defaultValue"
              :brand-link="brandLink"
            />
            <ArticleKeyWord
              v-if="defaultValue.tags.length"
              :list="defaultValue.tags"
              class="mt-4 d-lg-block d-none"
            />
          </BaseSticky>
          <!--<ArticleSticky>
            <ArticleSide :type="type" :info="defaultValue" :brand-link="brandLink"/>
            <ArticleKeyWord v-if="defaultValue.tags.length" :list="defaultValue.tags"/>
          </ArticleSticky>-->
        </div>

      </div>
    </div>
  </BrandLayout>
</template>
<style lang="scss" module>
  .video {
    position: relative;
    z-index: 0;
    padding-top: 56%;
    cursor: pointer;
    background: #EEE;
    background-position: center;
    background-size: cover;

    :global {
      .youtube {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
</style>

